/*******************************************************************************

Copyright (c) 2020-2021, Visual Elements

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*******************************************************************************/

// @format

import { parseHeatMapData, parseStreamGraphData, parseTimelineData, parseSunburstData, parsePackedBubbleData, parsePackedBubbleAssigns } from './highed.data.parse';

// plugins needed for specific chart types

export default {
  sankey: {
    modules: ['https://code.highcharts.com/modules/sankey.js'],
  },
  dependancywheel: {
    modules: [
      'https://code.highcharts.com/modules/sankey.js', 
      'https://code.highcharts.com/modules/dependency-wheel.js'
    ]
  },
  parliament: {
    modules: [
      'https://code.highcharts.com/modules/item-series.js',
      'https://app.everviz.com/resources/js/highcharts-font-awesome.js'
    ],
    config: {
      chart: {
        events: {
          render: function() {
            // eslint-disable-next-line consistent-this
            let chart = this;
            let originPoints;

            if (chart.series[0].data[0]) originPoints = chart.series[0].data[0].graphics;
            else return;

            chart.series[0].data.forEach(function(d) {
              const graphics = d.graphics;
              const keys = Object.keys(graphics);
              for (let i = 0; i < keys.length; i++) {
                if (originPoints[0] && originPoints[0].element) {

                  graphics[keys[i]].element.style['font-size'] = originPoints[0].element.getAttribute('height') + 'px';
                  if (graphics[keys[i]].element.style['font-family'] === 'FontAwesome') {
                    graphics[keys[i]].element.style.transform = 'translateY(' + originPoints[0].element.getAttribute('height') + 'px)';
                  }
                }
              }
            });
          }
        }
      }
    }
  },
  wordcloud: {
    modules: ['https://code.highcharts.com/modules/wordcloud.js']
  },
  dumbbell: {
    modules: ['https://code.highcharts.com/modules/dumbbell.js']
  },
  vector: {
    modules: ['https://code.highcharts.com/modules/vector.js']
  },
  pyramid3d: {
    modules: [
      'https://code.highcharts.com/modules/cylinder.js',
      'https://code.highcharts.com/modules/funnel3d.js',
      'https://code.highcharts.com/modules/pyramid3d.js'
    ]
  },
  funnel3d: {
    modules: [
      'https://code.highcharts.com/modules/cylinder.js',
      'https://code.highcharts.com/modules/funnel3d.js',
      'https://code.highcharts.com/modules/pyramid3d.js'
    ]
  },
  sunburst: {
    modules: ['https://code.highcharts.com/modules/sunburst.js'],
    parseData: parseSunburstData
  },
  heatmap: {
    modules: ['https://code.highcharts.com/modules/heatmap.js'],
    parseData: parseHeatMapData
  },
  packedbubble: {
    parseData: parsePackedBubbleData,
    parseAssigns: parsePackedBubbleAssigns
  },
  timeline: {
    modules: ['https://code.highcharts.com/modules/timeline.js'],
    parseData: parseTimelineData
  },
  streamgraph: {
    modules: ['https://code.highcharts.com/modules/streamgraph.js'],
    parseData: parseStreamGraphData
  },
  'icon-chart': {
    modules: [
      'https://code.highcharts.com/modules/item-series.js',
      'https://app.everviz.com/resources/js/highcharts-font-awesome.js'
    ],
    config: {
      chart: {
        events: {
          render: function() {
            let chart = this;
            let originPoints;

            if (chart.series[0].data[0]) originPoints = chart.series[0].data[0].graphics;
            else return;

            chart.series[0].data.forEach(function(d) {
              const graphics = d.graphics;
              const keys = Object.keys(graphics);
              for (let i = 0; i < keys.length; i++) {
                if (originPoints[0] && originPoints[0].element) {

                  graphics[keys[i]].element.style['font-size'] = originPoints[0].element.getAttribute('height') + 'px';
                  if (graphics[keys[i]].element.style['font-family'] === 'FontAwesome') {
                    graphics[keys[i]].element.style.transform = 'translateY(' + originPoints[0].element.getAttribute('height') + 'px)';
                  }
                }
              }
            });
          }
        }
      }
    }
  }
};
